import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import {
    addHours,
    addMinutes,
    DisplayDate,
    now,
    isSameDay,
    startOfDay,
    startOfHour,
} from 'owa-datetime';

/**
 * Calculate default start times for the provided date.
 * for Today's date returns beginning of start of next hour
 * for other days returns start of working hours
 */
export default function getDefaultStart(date: DisplayDate): DisplayDate {
    let todayTime = now();
    if (isSameDay(todayTime, date)) {
        return addHours(startOfHour(todayTime), 1);
    } else {
        // TZ_BUG(fpintos): working hours might be in different time zone
        let { WorkingHours } = getUserConfiguration().UserOptions;
        return addMinutes(startOfDay(date), WorkingHours.WorkHoursStartTimeInMinutes);
    }
}
